import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';

const RequirementGroupPreview = ({ group }) => {
	if (!Array.isArray(group) || group.length === 0) return null;
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				gap: 0.5,
				flexWrap: 'wrap',
				padding: 0.75,
				border: '1px dashed',
				borderColor: 'grey.400',
				borderRadius: 1,
			}}
		>
			{group.map((id, i) => (
				<React.Fragment key={id}>
					{i > 0 && (
						<Typography variant="caption" sx={{ fontSize: '0.6rem', color: 'text.secondary', fontWeight: 600 }}>OR</Typography>
					)}
					<Chip label={id} size="small" variant="outlined" sx={{ height: 20, fontSize: '0.7rem' }} />
				</React.Fragment>
			))}
		</Box>
	);
};

const WorkActivityQuestion = ({ label, questionText, requiredDocumentTypeIds = [] }) => {
	const groups = Array.isArray(requiredDocumentTypeIds) ? requiredDocumentTypeIds.filter(g => Array.isArray(g) && g.length > 0) : [];

	return (
		<Box sx={{ padding: 0.5 }}>
			<Typography variant="body2" sx={{ fontWeight: 500 }}>
				{label || 'Unnamed activity'}
			</Typography>
			{questionText && (
				<Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
					{questionText}
				</Typography>
			)}
			{groups.length > 0 && (
				<Box sx={{ mt: 0.75, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
					{groups.map((group, i) => (
						<React.Fragment key={i}>
							<RequirementGroupPreview group={group} />
							{i < groups.length - 1 && (
								<Divider sx={{ fontSize: '0.6rem', color: 'text.secondary', fontWeight: 600 }}>AND</Divider>
							)}
						</React.Fragment>
					))}
				</Box>
			)}
			{groups.length === 0 && (
				<Typography variant="caption" sx={{ color: 'text.disabled', fontStyle: 'italic', display: 'block', mt: 0.25 }}>
					No document types configured
				</Typography>
			)}
		</Box>
	);
};

WorkActivityQuestion.type = 'WorkActivityQuestion';

WorkActivityQuestion.spec = [{
	name: 'WorkActivityQuestion',
	key: 'WorkActivityQuestion',
	category: 'input',
	title: 'Work Activity Question',
	icon: 'HelpCircle',
	translatable: ['questionText'],
	defaultProperties: {
		label: '',
		questionText: '',
		requiredDocumentTypeIds: [[]],
	},
	fields: [
		{
			type: 'TextField',
			label: 'Activity key',
			name: 'label',
		},
		{
			type: 'TextField',
			label: 'Question text',
			name: 'questionText',
		},
		{
			type: 'RequirementGroupsEditor',
			name: 'requiredDocumentTypeIds',
			label: 'Document Type Requirements',
			dataSource: '/api/data-sources/document-types/data',
		},
	],
}];

export default WorkActivityQuestion;
